import { Translatable } from 'src/packages/mitsBasics';
import { IChecklistModule } from './checklist-module';

export interface IChecklistGroup extends Translatable<IChecklistGroup> {
  /** Title of this group */
  title: string;
  /** ID of assosiated checklist */
  checklist_id: number;
  /** Modules of this group */
  modules: IChecklistModule[];
  /** Index of sorting */
  sort_index: number;
  /** Deletes this module in backend */
  _destroy: boolean;
}

export function instanceOfIChecklistGroup(
  object: any
): object is IChecklistGroup {
  return (
    'modules' in object &&
    'title' in object &&
    !('groups' in object) &&
    !('dep' in object)
  );
}
